import { TransactionOperation } from '../storage/transaction-operation.js';
import { array } from '../typing/array.js';
import { object } from '../typing/object.js';
import { union } from '../typing/union.js';
import { literal } from '../typing/literal.js';
import { string } from '../typing/string.js';
import { TypeOf } from '../typing/type-of.js';
import { EventAuth } from '../event-store/event-auth.js';
import { record } from '../typing/record.js';
import { StateValue } from '../storage/state-value.js';
import { optional } from '../typing/optional.js';
export {
  PermissionEvents,
  AccessLevel,
  FieldFilter,
  TerminalMethod,
  EventGrant,
  StateGrant,
  EventRevoke,
  StateRevoke,
} from './permission-grant-schema.js';

export const PermissionLevel = union('PermissionLevel', [
  literal('read'),
  literal('write'),
  literal('readwrite'),
]);

export const PermissionChangeType = union('PermissionChangeType', [
  literal('grant_event'),
  literal('revoke_event'),
]);

export const PermissionChange = object('PermissionChange', {
  type: PermissionChangeType,
  event: string(),
  permission: PermissionLevel,
  auth: EventAuth,
});

export const HostPushSuccessResult = object('HostPushSuccessResult', {
  success: literal(true),
  operation: array(TransactionOperation), // TODO remove from result
  outputs: array(
    object('HostPushSuccessResultOutput', {
      id: string(),
      type: string(),
      sourceEventId: string(),
      data: record(string(), StateValue),
    }),
  ), // TODO remove from result
  auth: EventAuth,
  event: string(),
  eventId: string(),
});
export type HostPushSuccessResult = TypeOf<typeof HostPushSuccessResult>;

export const HostPushFailResult = object('HostPushFailResult', {
  success: literal(false),
  error: string(),
  stacktrace: optional(string()),
  eventId: string(),
});
export type HostPushFailResult = TypeOf<typeof HostPushFailResult>;

export const RuntimeResult = union('RuntimeResult', [
  HostPushSuccessResult,
  HostPushFailResult,
]);
export type RuntimeResult = TypeOf<typeof RuntimeResult>;
